module.exports = __webpack_public_path__ + "static/media/medicare-guide-2025.2e853b97.png";